import React from 'react';

const ContactMap: React.FC = () => {
  // OpenStreetMap embed URL centered exactly near Nehru Nagar, Chromepet with a padded bounding box for zoom
  const mapUrl = "https://www.openstreetmap.org/export/embed.html?bbox=80.139823%2C12.939045%2C80.145823%2C12.945045&layer=mapnik&marker=12.942045%2C80.142823";
  //https://www.openstreetmap.org/?#map=19/12.942045/80.142823

  // Directions link for the user to open in a new tab
  const directionsUrl = "https://www.openstreetmap.org/?mlat=12.942045&mlon=80.142823##map=19/12.942045/80.142823";

  return (
    <div style={{ width: '100%' }}>
      <div style={{ height: '350px', width: '100%', borderRadius: '8px', overflow: 'hidden', border: '1px solid #e0e0e0' }}>
        <iframe
          title="Prathitha Digital Printers Location Map"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          src={mapUrl}
          allowFullScreen
        />
      </div>
      <div style={{ marginTop: '8px', textAlign: 'right' }}>
        <a
          href={directionsUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{ fontSize: '13px', color: '#007bff', textDecoration: 'none', fontWeight: 500 }}
        >
          🗺️ View Larger Map / Get Directions
        </a>
      </div>
    </div>
  );
};

export default ContactMap;